import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { validSelected, autoComplete, pushToArray, pageKey, toNumber, checkExist } from 'src/app/services/mapping.service';
import { DataService } from 'src/app/services/data.service';
import { IRoom } from 'src/app/interfaces/country';
import { statusObj } from 'src/app/dummy/status';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-room',
  templateUrl: './add-room.component.html',
  styleUrls: ['./add-room.component.scss']
})
export class AddRoomComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputRef: ElementRef;

  form: FormGroup;
  name: AbstractControl;
  description: AbstractControl;
  floor: AbstractControl;
  roomType: AbstractControl;
  maxStudent: AbstractControl;
  minStudent: AbstractControl;
  building: AbstractControl;

  filteredStates: any;
  filteredFloorStates: any;
  ROOM_TYPES: Array<any>;

  constructor(
    public dialogRef: MatDialogRef<AddRoomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
    public store: List,
    private ds: DataService,
  ) {
  }

  async buildForm() {
    this.form = this.fb.group({
      name: [null, Validators.required, checkExist(this.ds.dbRef(), 'rooms', 'name')],
      description: [null],
      maxStudent: [null],
      minStudent: [null],
      roomType: [null, Validators.required],
      floor: [null, Validators.compose([Validators.required, validSelected.bind(this)])],
      building: [null, Validators.compose([Validators.required, validSelected.bind(this)])]
    });

    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.building = this.form.controls['building'];
    this.floor = this.form.controls['floor'];
    this.maxStudent = this.form.controls['maxStudent'];
    this.minStudent = this.form.controls['minStudent'];
    this.roomType = this.form.controls['roomType'];

    const shifts = await this.ds.buildingRef(ref => ref.orderBy("name")).get().toPromise();
    this.filteredStates = autoComplete(this.building, pushToArray(shifts), 'name');
    const floors = await this.ds.floorRef(ref => ref.orderBy("order")).get().toPromise();
    this.filteredFloorStates = autoComplete(this.floor, pushToArray(floors), 'name');
    this.ROOM_TYPES = await this.store.fetchList(this.ds.roomTypeRef(ref => ref.orderBy('name')));
    this.form.patchValue({
      roomType: this.ROOM_TYPES ? this.ROOM_TYPES[0] : null,
    })
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) { return o1.key === o2.key; }
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  async ngOnInit() {
    await this.buildForm();
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { name, description, building, roomType, floor, maxStudent, minStudent } = f;
      const { campusKey } = building;
      const item: IRoom = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        name: name,
        description: description,
        status: statusObj.active,
        campusRef: this.ds.campusRef().doc(`${campusKey}`).ref,
        campusKey: campusKey,
        buildingKey: building.key,
        buildingRef: this.ds.buildingRef().doc(building.key).ref,
        floorKey: floor.key,
        floorRef: this.ds.floorRef().doc(floor.key).ref,
        roomTypeKey: roomType.key,
        roomTypeRef: this.ds.roomTypeRef().doc(roomType.key).ref,
        minStudent: toNumber(minStudent),
        maxStudent: toNumber(maxStudent),
      };
      this.store.save(this.ds.roomsRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Room has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            roomType
          })
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }
  }

}
